module.exports = __webpack_public_path__ + "img/60.9.TU.cc92ba2b.png";